import React from 'react';
import { render } from 'react-dom';

import Main from './Main';

declare global {
  interface Window {
    DatoCmsPlugin:any;
  }
}

window.DatoCmsPlugin.init((plugin: any) => {
  plugin.startAutoResizer();

  const container = document.createElement('div');
  document.body.appendChild(container);

  render(<Main plugin={plugin} />, container);
});
